import Page from "@pages/studies/index";

export const StudiesHome = {
	name: "studies",
	path: "/studies",
	component: Page,
	meta: {
		title: "Studies"
	}
};